import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";

// JS Files
import { CustomerBasketProvider } from "../../../context/CustomerBasketContext";

// Routes
import CreateOrder from "../../customer-panels/create-order/CreateOrder";
import NewOrders from "../orders/new-orders/NewOrders";
import CustomerSetParameter from "../../customer-panels/setting/parameter/CustomerSetParameter";
import CustomerMessages from "../../customer-panels/messages/CustomerMessages";
import Chats from "../../customer-panels/chats/Chats";
import PrintOrders from "../../customer-panels/orders/PrintOrders";
import PrintOrderDetails from "../../customer-panels/orders/PrintOrderDetails";
import PrintNewOrder from "../orders/new-orders/PrintNewOrder";

const EmployeeRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/create-order" />} />
        <Route path="/new-orders" element={<NewOrders />} />
        <Route
          path="/print-new-orders/:order_type/:unique_id/:date"
          element={<PrintOrders />}
        />
        {/* <Route path="/set-parameter" element={<Parameterrr />} /> */}
        <Route
          path="/create-order"
          element={
            <CustomerBasketProvider>
              <CreateOrder />
            </CustomerBasketProvider>
          }
        />
        <Route
          path="/setting-set-parameter"
          element={<CustomerSetParameter />}
        />
         <Route
          path="/print-order-details/:id"
          element={<PrintOrderDetails />}
        />
          <Route
          path="/print-new-orders/:unique_id/:date"
          element={<PrintNewOrder />}
        />
        {/*..................Chats................... */}
        <Route path="/chats" element={<Chats />} />
        <Route path="/messages" element={<CustomerMessages />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};
export default EmployeeRoutes;
